<div class="main-container">
  <header *ngIf="!isNotFoundPage">
    <app-header></app-header>
  </header>
  <div class="middle-container">
    <ngx-ui-loader [hasProgressBar]="false" [fgsTemplate]="dnbLoader" [overlayColor]="'rgba(255, 255, 255, 0.8)'">
    </ngx-ui-loader>
    <ng-template #dnbLoader>
      <div><img src="../assets/images/common/dnb-loading.gif" alt="D&B loading indicator" /></div>
    </ng-template>
    <router-outlet></router-outlet>
  </div>
  <div *ngIf="countryData?.cgPageFeedback">
    <button (click)="triggerSurvey()" role="button" id="CGFeedbackButton-btn" aria-expanded="false"
      class="page-feedback-button">
      <div class="page-feedback">
        <div>
          <div class="page-feedback-placement"><svg width="13" height="15" viewport="0 0 13 15">
              <path
                d="M11.8182 0H1.18182C0.529118 0 0 0.610521 0 1.36364V13.6364C0 14.3895 0.529118 15 1.18182 15H11.8182C12.4709 15 13 14.3895 13 13.6364V1.36364C13 0.610521 12.4709 0 11.8182 0Z"
                fill="#ffffff"></path>
              <path d="M3.11869 4.01514H9.88131" stroke="#0075a3" strokeLinecap="round" strokeLinejoin="round"></path>
              <path d="M3.11869 7.65151H9.88131" stroke="#0075a3" strokeLinecap="round" strokeLinejoin="round"></path>
              <path d="M3.11869 11.2879H9.88131" stroke="#0075a3" strokeLinecap="round" strokeLinejoin="round"></path>
            </svg></div>
        </div>
        <div class="pl-4 ml-4">{{'pageFeedback' | translate}}</div>
      </div>
    </button>
  </div>
 <ng-container *ngIf="(authService.isAuthenticated$ | async) && country === 'us'">
    <app-chat-dnb-widget></app-chat-dnb-widget>
  </ng-container> 

  <footer *ngIf="!isNotFoundPage">
    <app-footer></app-footer>
  </footer>
</div>
